import { highlightMatch } from '../lib/highlightMatch';

interface HasStaticCommandMatchParams {
  label: string;
  aliases: string[];
  query: string;
}

export const hasStaticCommandMatch = ({
  label,
  aliases,
  query,
}: HasStaticCommandMatchParams): boolean =>
  [label, ...aliases].some((text) =>
    highlightMatch({ text, query }).some((segment) => segment.isMatch),
  );
